import { ConfigHeader } from "../../types/config";
import {
  facebookIcon,
  instagramIcon,
  tiktokIcon,
  youtubeIcon,
} from "../icons/socialIcons";

export const configHeader: ConfigHeader = {
  megaMenu: {
    newsletter: {
      text: "Sign up for our weekly newsletters for the best fashion, beauty, travel and exclusive events",
      url: "/newsletter-signup",
      buttonText: "SIGN UP",
    },
    closeButton: {
      type: "icon",
      placement: "right",
    },
  },
  socialMedia: {
    target: "_blank",
    icons: [
      {
        icon: instagramIcon,
        name: "Instagram",
        href: "https://www.instagram.com/nuyousingapore",
      },
      {
        icon: facebookIcon,
        name: "Facebook",
        href: "https://www.facebook.com/nuyousingapore",
      },
      {
        icon: youtubeIcon,
        name: "Youtube",
        href: "https://www.youtube.com/@nuyousingapore6176",
      },
      {
        icon: tiktokIcon,
        name: "Tiktok",
        href: "https://www.tiktok.com/@nuyousingapore",
      },
    ],
  },
};
